import {FaLeanpub} from "react-icons/fa"

const fa = {
    FaLeanpub
}

const fa6 = {}

function getIcon(iconName) {
    const names = iconName.split("/")

    let m = names[0] || "fa"
    const icon = names[1]


    switch (m) {
        case "fa":
            return fa[icon]
        case "fa6":
            return fa6[icon]
        default:
            return null;
    }

    return null
}

export default function MenuIcon({iconName, ...other}) {
    const IconComponent = getIcon(iconName)
    if (!IconComponent) {
        console.log("MenuIcon CANT find ICON => (Add and Rebuild)", iconName)
        return null;
    }

    return (
        <IconComponent {...other} />
    );
}
